module.exports = __webpack_public_path__ + "static/BMC-d541cbdcd324bdd4b9ad0511b707cd96.png";